import gql from 'graphql-tag';

export const CREATE_CUSTOMER = gql`
  mutation createCustomer($input: CreateCustomerInput!) {
    createCustomer(input: $input) {
      customer {
        id
        firstName
        lastName
        fullName
        email
        phone
        mobilePhone
        alertNotes
        blocked
        address
        zipcode
        city
        dateOfBirth
        personalRegistrationNumber
        insuranceProvider
      }
    }
  }
`;
